module.exports = {"version":"0.20.2"}


//////////////////
// WEBPACK FOOTER
// ./~/truffle-blockchain-utils/~/web3/lib/version.json
// module id = WP4h
// module chunks = 1